import React, { ReactElement } from 'react';
import { FormDialog } from 'dialog';
import { CheckIcon } from 'components/icons';
import { EditJobsiteFormFormData } from 'containers/jobsiteConfiguration/types';
import { EditJobsiteFormModalProps } from './types';
import { getDefaultValues, getFormInputsHook } from './JobsiteFormModal.forms';

export function EditJobsiteFormModal(
  props: EditJobsiteFormModalProps,
): ReactElement {
  const {
    isOpen,
    onCancel,
    onConfirm,
    jobsiteForm,
    jobsiteForms,
    formsOptions,
  } = props;
  const [isFormDirty, setIsFormDirty] = React.useState(false);

  const onSubmit = React.useCallback(
    (data: EditJobsiteFormFormData): void => {
      onConfirm?.({ ...jobsiteForm, ...data });
    },
    [onConfirm, jobsiteForm],
  );

  const formInputs = React.useMemo(
    () => getFormInputsHook({ jobsiteForms, jobsiteForm, formsOptions }),
    [jobsiteForms, jobsiteForm, formsOptions],
  );
  const defaultValues = React.useMemo(
    () => getDefaultValues(jobsiteForm),
    [jobsiteForm],
  );

  return (
    <FormDialog
      id="editJobsiteForm"
      open={isOpen}
      setOpen={onCancel}
      onIsDirtyChange={setIsFormDirty}
      title="Edit Log"
      variant="drawer"
      inputs={formInputs}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      actionText="Save Changes"
      actionIcon={CheckIcon}
      actionButtonEnabled={isFormDirty}
    />
  );
}
